import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  SupportTicket,
  SupportTicketComment
} from '../views/SupportTickets/SupportTickets.types';
import {
  addCommentSupportTicket,
  createSupportTicket,
  getCommentsSupportTicket,
  getSupportTicket
} from '../views/SupportTickets/SupportTickets.actions';

export interface accountingSliceType {
  loading: boolean;
  tickets: SupportTicket[];
  selectedTicket: {
    ticket: SupportTicket | null;
    comments: SupportTicketComment[];
  };
}

const initialState = {
  loading: false,
  tickets: [],
  selectedTicket: {
    ticket: null,
    comments: []
  }
} as accountingSliceType;

const ticketsSlice = createSlice({
  name: 'accounting',
  initialState,
  reducers: {
    removeSelectedTicket(state) {
      (state.selectedTicket.ticket = null),
        (state.selectedTicket.comments = []);
    },
    setSelectedTicket(state, { payload }) {
      state.selectedTicket.ticket = payload;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(getSupportTicket.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSupportTicket.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.tickets = payload ?? [];
    });
    builder.addCase(getSupportTicket.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(createSupportTicket.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createSupportTicket.fulfilled, (state, { payload }) => {
      state.loading = false;
      if (payload) {
        state.tickets = [...state.tickets, payload];
      }
    });
    builder.addCase(createSupportTicket.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getCommentsSupportTicket.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getCommentsSupportTicket.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.selectedTicket.ticket = payload.ticket ?? null;
        state.selectedTicket.comments = payload.comments ?? [];
      }
    );
    builder.addCase(getCommentsSupportTicket.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(addCommentSupportTicket.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addCommentSupportTicket.fulfilled, (state, { payload }) => {
      state.loading = false;
      if (payload) {
        state.selectedTicket.comments = [
          ...state.selectedTicket.comments,
          payload
        ];
      }
    });
    builder.addCase(addCommentSupportTicket.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const { removeSelectedTicket, setSelectedTicket } = ticketsSlice.actions;

export default ticketsSlice.reducer;
